export default __webpack_public_path__ + "static/cafe_36004-4eae11b0974a325d398c6de3e56929d9.png";